<template>
  <div id="view">
    <div class="vx-col w-full mb-base">
      <vx-card ref="infoCard" :title="cardTitle" title-color="black">
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <vs-button type="border" class="mr-3" icon-pack="feather" icon="icon-save" @click="saveData" v-if="selectedTab==0">{{ $t('Save') }}</vs-button>
            <vs-button type="border" class="mr-3" color="danger" @click="returnToList">{{ $t('Cancel') }}</vs-button>
          </vs-col>
        </vs-row>
        
          <vs-tabs v-model="selectedTab" :key="tabsKey">
            <vs-tab value="0" :label="$t('CashFlow.YearlyFxRateTemplate.Tab1Title')" icon-pack="feather" icon="icon-settings">
              <ValidationObserver ref="observer">
                <div class="p-6">
                  <vs-row class="mb-3">
                    <vs-col vs-w="6" class="mr-5">
                      <vs-row class="mb-3">
                        <vs-col vs-w="6">
                          <ValidationProvider :name="$t('CashFlow.YearlyFxRateTemplate.Name')" rules="required" v-slot="{ errors }">
                            <validated-input
                              :label="$t('CashFlow.YearlyFxRateTemplate.Name')"
                              v-model="name"
                            ></validated-input>
                            <validation-message>{{ errors[0] }}</validation-message>
                          </ValidationProvider>
                        </vs-col>
                      </vs-row>
                    </vs-col>               
                  </vs-row>
                </div>
              </ValidationObserver>
            </vs-tab>
            <vs-tab :disabled="id === 0"  value="1" :label="$t('CashFlow.YearlyFxRateTemplate.Tab2Title')" icon-pack="feather" icon="icon-calendar" v-b-tooltip.hover :title="id === 0 ? $t('CashFlow.YearlyFxRateTemplate.Tab2Unavailable') : ''">
                <yearly-fx-rates
                  ref="yearlyRates"
                  :yearlyRates="yearlyRates"
                  :templateId="id"
                  @onRebindYearlyRates="bindYearlyRates"
                />
            </vs-tab>
          </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<script>

import YearlyFxRates from './components/yearlyFxRates.vue'
import module from "@/store/cashflow/moduleCashFlow.js";
import {
  ValidatedInput,
  ValidationMessage
} from "../../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    YearlyFxRates
  },
  data() {
    return {
      id: 0,
      name : '',      
      selectedTab: 0,
      yearlyRates: [],
      tabsKey: 0
    };
  },
  watch: {
  },
  computed: {
    cardTitle()  {
      if (this.id !== null && this.id > 0)
        return this.name;
      else
        return this.$t('CashFlow.YearlyFxRateTemplate.AddNew');
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("cashflow", module);
      module.isRegistered = true;
    }
    if (this.$route.params.editData !== undefined && this.$route.params.editData !== null) {
      this.id = this.$route.params.editData.id;
      this.refreshModel();
    }
    else {
      this.initValues();
    }
  },
  mounted() {
  },

  methods: {
    refreshModel() {
      this.$cqrsGet("cashflow/lom/yearlyFxRateTemplates/find/", { params : { id: this.id }})
        .then((response) => {
          this.id = response.data.model.id;
          this.name = response.data.model.name;          
          this.yearlyRates = response.data.model.yearlyRatesByCurrency;
        })
        .finally(() => {
          this.$refs.infoCard.removeRefreshAnimation()
        });
    },
    initValues() {
      if (this.data) return;
      this.id = 0;
      this.name = "";
      this.selectedTab = 0;
      this.yearlyRates = [];
    },
    saveData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          this.$vs.loading();
          const yearlyFxRateTemplate = {
            id: this.id,
            name: this.name
          };
          if (this.id !== null && this.id > 0) {
            this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/edit', { yearlyFxRateTemplate })
              .then((response) => {
                this.$notifySaveSuccess();
                this.yearlyRates = response.data.model.yearlyRatesByCurrency;
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          } else {
            this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/create', { yearlyFxRateTemplate })
              .then((response) => {                
                this.$notifySaveSuccess();
                this.id = response.data.model.id;
                this.yearlyRates = response.data.model.yearlyRatesByCurrency;
              })
              .finally(() => {
                this.selectedTab = 2;
                this.forceRefreshTabs();
                this.$vs.loading.close();
              });
          }
        }
      });
    },
    returnToList() {
      this.$router.push({ name: 'BSG-CashFlow-Templates-YearlyFxRateTemplates'});
    },
    bindYearlyRates(model) {
      this.yearlyRates = model;
    },
    forceRefreshTabs() {
      this.tabsKey++;
    }
  }
};
</script>
